// extracted by mini-css-extract-plugin
export default {"remove-focus-within-border":"styles_remove-focus-within-border__IoaZ4"};